import { render } from "./StageView.vue?vue&type=template&id=1b8f4f26&scoped=true&ts=true"
import script from "./StageView.vue?vue&type=script&lang=ts"
export * from "./StageView.vue?vue&type=script&lang=ts"

import "./StageView.vue?vue&type=style&index=0&id=1b8f4f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8f4f26"]])

export default __exports__